export const config = {
  api_local: process.env.REACT_APP_API_URL, 
  BE_API_URL: process.env.REACT_APP_API_URL,
  site: process.env.REACT_APP_SITE,
  LIST_BANK_NAME: [
    'ABBANK',
    'AC Bank limited',
    'ACB',
    'Agribank',
    'Asia Commercial Bank',
    'BAC Community Bank',
    'BacABank',
    'BaoVietBank, BVB',
    'BIDV',
    'CAKE',
    'CB',
    'CIMB',
    'COOPBANK',
    'DongA Bank',
    'Eximbank',
    'GPBank',
    'HD BANK',
    'Hong Leong Bank',
    'HSBC',
    'IVB',
    'KASIKORNBANK Public Company Limited',
    'KBANK ( KASIKORNBANK )',
    'KienLongBank',
    'LienVietPostBank, LPB',
    'LioBank',
    'Maritime Bank, MSB',
    'MB BANK',
    'MCB Bank',
    'Mekong Housing Bank',
    'Military Bank, MBB',
    'Nam A Bank',
    'National Citizen Bank, NCB',
    'Oceanbank',
    'Orient Commercial Bank, OCB',
    'PG bank',
    'Public Bank Berhad',
    'PVcomBank',
    'Sacombank',
    'Saigonbank, SGB',
    'SCB',
    'SeABank',
    'SHBank, SHB',
    'SHINHAN BANK',
    'Techcom Bank',
    'Timo',
    'TPBank',
    'UBANK',
    'UNITED OVERSEAS BANK- UOB',
    'VBSP',
    'VIBBank, VIB',
    'VietABank, VAB',
    'Vietbank, VB',
    'VietCapitalBank',
    'Vietcombank',
    'Vietin Bank',
    'Vietnam Development Bank - VDB',
    'VPBank',
    'VRB (VIET NGA)',
    'WOORIBANK',    
  ],
  LIST_REQUEST_BANK: [
    "Thêm ngân hàng",
    "Sửa ngân hàng",
    "Thay đổi cả ngân hàng và họ tên",
  ],
};